export default __webpack_public_path__ + "static/google_cloud_partner-8bc5a6d608fab68cd865dd20e33dca67.png";